import React, { useContext } from 'react';
import ProfilePic from "../../Layout/ProfilePic";
import PreviewSpecial from "Components/PreviewSpecial"
import { GlobalContext } from '../../../Context/GlobalContext';

const LiveStreamsPage = ({ 
  payload, 
  setFile, 
  color, 
  parseLive, 
  parseText 
}) => {
  const { viewerObj } = useContext(GlobalContext);
  

  const { config } =
    useContext(GlobalContext);

  const liveStreams = payload && payload["live"]
    ? payload["live"].map(liveStreamObj => {

      let notAccessible;
      const monetizedFile = liveStreamObj?.metadata?.associatedSubscriptions;

      if(monetizedFile) {
        // check if the file has any active subscriptions associated with it
        if (Object.keys(monetizedFile).length === 0) return;
        const product_Id = viewerObj?.subscription?.product_Id; 
        const activeSub = monetizedFile.hasOwnProperty(product_Id);
        // if the viewer doesn't have the correct sub apply decrease img brightness on thumbnail as visual feedback
        notAccessible = !activeSub ? true : false;
      } 
      
      // ? whatever this is for, it seems to not currently work
      // let comments = [...liveStreamObj.comments]
      //   .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      //   .filter((liveStreamObj) => liveStreamObj.user && liveStreamObj.user.email)
      //   .slice(0, 4)
      //   .map((obj) => {
      //     return (
      //       <div className="flex-row mt-3" key={obj.user.email}>
      //         <div>
      //           <ProfilePic user={obj.user} />
      //         </div>
      //         <div className="ml-3">
      //           <div className="flex-row" style={{ alignItems: "center" }}>
      //             <p className="comment-text">
      //               {obj.user ? obj.user.email : ""}
      //             </p>
      //             <p className="dt ml-3 bold">
      //               {parseText(new Date(obj.date))}
      //             </p>
      //           </div>
      //           {obj.text}
      //         </div>
      //       </div>
      //     );
      //   });

        return (
          <div 
            key={liveStreamObj._id} 
            className="col mb-3 flex-row" 
            onClick={() => setFile(liveStreamObj, [], "live", notAccessible)}
          >
            <div className="flex-1">
              <PreviewSpecial 
                type={"live"} 
                item={liveStreamObj._id} 
                color={color}
                notAccessible={notAccessible} />
            </div>

            <div className="flex-1 ml-3">
              <p className="" style={{ fontSize: "2rem", marginBottom: "0" }}>
                {liveStreamObj.name}
              </p>
              {!config.hideViews && <p className="dt bold" style={{ fontSize: "1rem", marginTop: "0" }}
              >
                {parseLive(liveStreamObj.views)}
              </p>}
              {/* {comments} */}
            </div>
          </div>
        );
      })
    : null;


    return liveStreams;
}

export default LiveStreamsPage;